export default class ItemsLimitError {
	actual: number;

	limit: number;

	constructor(actual: number, limit: number) {
		this.actual = actual;
		this.limit = limit;
	}
}
